export default [
  // Centers
  {
    path: "/TnSTFuEw",
    children: [
      {
        path: "/154c0d538a021fe2cbacac1e",
        name: "baice26.centers",
        meta: {
          title: "BAICE 2026 centers",
          authRequired: true,
          acc: ["y68097"],
        },
        component: () =>
          import("@/views/baice/tws/center_management/index.vue"),
      },
      // view center
      {
        path: "/15b0af962fc75c61f833d0e7/:cn?",
        name: "baice26.center.view",
        meta: {
          title: "View BAICE 2026 center",
          authRequired: true,
          acc: ["y77222"],
        },
        component: () => import("@/views/baice/tws/center_management/view.vue"),
      },
      // assign center
      {
        path: "1617f607ddd19ad7daad199a/:cn?",
        name: "baice26.center.create",
        meta: {
          title: "Create BAICE 2026 center",
          authRequired: true,
          acc: ["y57052"],
        },
        component: () =>
          import("@/views/baice/tws/center_management/create.vue"),
      },
      //   {
      //     path: "hgnerugervbhoiuvervgye",
      //     name: "newCenters",
      //     meta: {
      //       title: "2025 baice NEW CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/newCenters.vue"),
      //   },
      //   {
      //     path: "center_requests",
      //     name: "newCenterRequest",
      //     meta: {
      //       title: "2025 baice NEW CENTERS Requests",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/requests.vue"),
      //   },
      //   {
      //     path: "center_request/:cn?",
      //     name: "CenterRequestv",
      //     meta: {
      //       title: "2025 baice Requests Details",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/request.vue"),
      //   },
      //   {
      //     path: ":cn/edit_center",
      //     name: "editCenter",
      //     meta: {
      //       title: "EDIT CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/baice/twf/center_management/edit-center.vue"),
      //   },
    ],
  },
];
